import { render, staticRenderFns } from "./InvoiceForm.vue?vue&type=template&id=1f64ffb2"
import script from "./InvoiceForm.vue?vue&type=script&lang=ts"
export * from "./InvoiceForm.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports